import { AnnouncementCardRead } from './AnnouncementCardRead';
export default AnnouncementCardRead;
